import React from 'react';
import { Link } from 'react-router-dom';

export default function CheckoutCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-dark-900 text-white">
      <div className="max-w-lg text-center p-8">
        <h1 className="text-2xl font-bold mb-4">Payment canceled</h1>
        <p className="mb-6">Your payment was canceled. You can try again from the pricing page.</p>
        <div className="space-x-4">
          <Link to="/pricing" className="btn btn-primary">Back to Pricing</Link>
          <Link to="/dashboard" className="btn btn-secondary">Go to Dashboard</Link>
        </div>
      </div>
    </div>
  );
}
